export enum MealName {
  Breakfast = 'Breakfast',
  Lunch = 'Lunch',
  Dinner = 'Dinner'
}

export enum SnackName {
  Snack_AM = 'Snack AM',
  Snack_PM = 'Snack PM',
  Snack_HS = 'Snack HS'
}
